import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DefaultLayout from "@/layouts/default-layout";
import ViewMeetsComp from "@/components/meets/view-meets-comp";
import ErrorBoundary from "@/components/error-boundries/error-boundry-comp";
import ViewMeetingDetailsComp from "@/components/v2/view-meeting-details-comp";

const MeetingDetailsPage = () => {
  const { short_code } = useParams();
  const [audioUrl, setAudioUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  return (
    <ErrorBoundary>
      <ViewMeetingDetailsComp _shortCode={short_code} readonly />
    </ErrorBoundary>
  );
};

export default MeetingDetailsPage;
